import { render, staticRenderFns } from "./new-organizations.vue?vue&type=template&id=04768b33"
import script from "./new-organizations.vue?vue&type=script&lang=js"
export * from "./new-organizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports